/**
 * 로그인 아이디. 이 앱은 한 사람(상담자 본인) 전용이라 아이디는 하나만 허용하고 새 아이디는 만들 수 없다.
 * 아이디 원문은 배포 코드에 넣지 않고 해시만 둔다. 실제 보호는 비밀번호(암호화 키)가 한다 — 아이디는 첫 관문.
 */
const ACCOUNT_ID_HASHES = new Set([
  '9e6b5c9e1c008245c78f7f141e915eb3ac20b3066a7d75affc4acf155c0a4ddb', // 김예찬
]);

export const normalizeAccountId = (id: string) => id.normalize('NFC').trim();

async function sha256Hex(text: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function isAllowedAccount(id: string): Promise<boolean> {
  const n = normalizeAccountId(id);
  if (!n) return false;
  return ACCOUNT_ID_HASHES.has(await sha256Hex(`sdcare-account|${n}`));
}
